// extracted by mini-css-extract-plugin
export default {"grid":"QC79S"};